export default __webpack_public_path__ + "static/media/Vambraces of the Fallen Empire (nm).58cf9963.jpg";